import { ROUTE_PATHS } from "utils/routerDom";

import { ADD_BUILDING_STEP_PARAM, STEP, URL_STEP_MAX, URL_STEP_MIN } from "../model/constants";

export const buildAddBuildingStepUrl = (projectId: string | undefined, stepNo: number): string => {
  const base = projectId ? ROUTE_PATHS.editBuilding(projectId).navigateUrl : ROUTE_PATHS.addBuilding().navigateUrl;
  return `${base}?${ADD_BUILDING_STEP_PARAM}=${stepNoToUrlValue(stepNo)}`;
};

export const stepNoToUrlValue = (stepNo: number): string => {
  const clamped = Math.min(Math.max(stepNo, 0), STEP.final);
  return String(clamped + 1);
};

export const urlValueToStepNo = (raw: null | string): number => {
  const parsed = raw ? parseInt(raw) : NaN;
  if (!Number.isFinite(parsed)) return 0;
  const clamped = Math.min(Math.max(parsed, URL_STEP_MIN), URL_STEP_MAX);
  return clamped - 1;
};
